import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ResolveFn } from '@angular/router';
import { ProviderStore } from '../../store/provider/provider.store';
import { filter, map, take } from 'rxjs';

export const getAllProivdersResolver: ResolveFn<any> = (route, state) => {
  const providerStore = inject(ProviderStore)
  providerStore.getProvidersSummaries()
  return toObservable(
    computed(() => ({
      status: providerStore.providersLoadingStatus(),
      found: providerStore.entities().length > 0
    }))
  ).pipe(
    filter(({status}) => status === 'success' || status === 'error'),
    take(1),
    map(({ found }) => found)
  )
};
